import React from 'react';
import * as R from 'ramda';
import * as Yup from 'yup';
import { withFormik } from 'formik';
import { pure, compose, withHandlers } from 'react-recompose';
// components
import { FormFooter } from '../../../components/form-footer';
import { FormSectionHeader } from '../../../components/form-section-header';
// forms
import { Fieldset2 } from '../../../forms';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// icons
import * as I from '../../../svgs';
// ui
import { Box, Flex } from '../../../ui';
//////////////////////////////////////////////////

const fieldSettings = [
  {
    isMulti: true,
    isRequired: true,
    type: 'reactSelect',
    options: 'itemOptions',
    useMenuPortalTarget: true,
    label: ['titles:items', 'Items'],
    inputWrapperStyles: { width: '100%' },
    fieldName: GC.FIELD_ITEM_TEMPLATE_GUIDS,
  },
];

const formEnhance = compose(
  withFormik({
    handleSubmit: ({ itemTemplateGuids }, { props: { submitAction } }) =>
      submitAction(itemTemplateGuids),
    validationSchema: Yup.object().shape({
      [GC.FIELD_ITEM_TEMPLATE_GUIDS]: G.yupArrayRequired.max(40, G.getShouldBePickOnlyLocaleTxt(40)),
    }),
    mapPropsToValues: ({ initialValues }) => G.setInitialFormikValues(
      { [GC.FIELD_ITEM_TEMPLATE_GUIDS]: [] },
      initialValues,
    ),
  }),
);

const ItemsForm = formEnhance((props) => {
  const { handleSubmit, itemOptions } = props;

  return (
    <form onSubmit={handleSubmit}>
      <Fieldset2
        {...G.getFormikProps(props)}
        fields={fieldSettings}
        itemOptions={itemOptions}
        fieldsWrapperStyles={{ mt: 15, mb: 20 }}
      />
      <FormFooter />
    </form>
  );
});

const enhance = compose(
  withHandlers({
    handleSetItems: ({ closeModal, setFieldValue }) => (guids) => {
      setFieldValue(GC.FIELD_ITEM_TEMPLATE_GUIDS, guids);

      if (G.isNotEmpty(guids)) closeModal();
    },
  }),
  withHandlers({
    handleRemoveItems: ({ handleSetItems }) => () => handleSetItems([]),
    handleOpenItemsForm: (props) => (editMode = false) => {
      const { openModal, itemOptions, handleSetItems, itemTemplateGuids } = props;

      const initialValues = G.ifElse(G.isTrue(editMode), { itemTemplateGuids }, null);

      const component = (
        <ItemsForm
          itemOptions={itemOptions}
          initialValues={initialValues}
          submitAction={handleSetItems}
        />
      );

      const modal = {
        p: 15,
        component,
        options: {
          width: 600,
          height: 'auto',
          maxHeight: '90vh',
        },
      };

      openModal(modal);
    },
  }),
  pure,
);

const iconColor = G.getTheme('colors.dark.blue');

export const ItemsSection = enhance((props) => {
  const { itemOptions, handleRemoveItems, itemTemplateGuids, handleOpenItemsForm } = props;

  const hasItems = G.isNotNilAndNotEmpty(itemTemplateGuids);
  const optionsMap = R.indexBy(R.prop(GC.FIELD_VALUE), itemOptions);

  return (
    <FormSectionHeader
      expanded={true}
      title={G.getWindowLocale('titles:items', 'Items')}
      action={G.ifElse(hasItems, null, handleOpenItemsForm)}
    >
      {
        hasItems &&
        <Flex pr={20} width='calc(100% - 50px)'>
          <Flex pl={20} pr={15}>
            <Box mr={15} cursor='pointer' onClick={handleRemoveItems}>
              {I.trash(iconColor)}
            </Box>
            <Box cursor='pointer' onClick={() => handleOpenItemsForm(true)}>
              {I.pencil(iconColor)}
            </Box>
          </Flex>
          <Box py={10} width='100%' wordBreak='break-word'>
            {
              G.createStringFromArray(itemTemplateGuids.map((guid) => (
                R.pathOr('', [guid, GC.FIELD_LABEL], optionsMap)
              )), ', ')
            }
          </Box>
        </Flex>
      }
    </FormSectionHeader>
  );
});
